import {
    IVR as PREFIX,
} from '../const';

const initialState = {
    list: [],
    loading: true,
    types: [],
    random_sound_folders: [],
    structured_sound_folders: [],
    selectedId: null
};

const handlers = {
    ['SET_ITEMS_' + PREFIX]: (state, {payload: {list}}) => ({...state, list: list}),
    ['SET_LOADING_' + PREFIX]: (state, {payload}) => ({...state, loading: payload}),
    ['SET_TYPES_' + PREFIX]: (state, {payload: {types, random_sound_folders, structured_sound_folders}}) => ({
        ...state, types: types, random_sound_folders: random_sound_folders, structured_sound_folders: structured_sound_folders
    }),
    ['SET_SELECTED_ID' + PREFIX]: (state, {payload}) => ({...state, selectedId: payload}),
    DEFAULT: state => state
};

export default (state = initialState, action) => {
    const handle = handlers[action.type] || handlers.DEFAULT;
    return handle(state, action);
}